import React, { useState, useEffect } from 'react';
import './CRPEntPage.css';

const CRPEntPage = () => {
  const [timeLeft, setTimeLeft] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    guests: 1,
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const targetDate = new Date('2026-05-01T18:00:00+02:00');

    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        setTimeLeft({ months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      let months = (targetDate.getFullYear() - now.getFullYear()) * 12;
      months += targetDate.getMonth() - now.getMonth();
      if (targetDate.getDate() < now.getDate()) {
        months--;
      }

      const adjustedTarget = new Date(targetDate);
      adjustedTarget.setMonth(adjustedTarget.getMonth() - months);

      const remainingDifference = adjustedTarget - now;

      const days = Math.floor(remainingDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remainingDifference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remainingDifference / 1000 / 60) % 60);
      const seconds = Math.floor((remainingDifference / 1000) % 60);

      setTimeLeft({ months, days, hours, minutes, seconds });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'guests' ? parseInt(value) || 1 : value,
    }));
  };

  const handleRSVP = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // ←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←
    // REPLACE THIS URL WITH YOUR GOOGLE APPS SCRIPT WEB APP URL
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyZxiUvKczRmLqls-v-gv9uIna4WAy8xJiyMJY2hibXNjN9t0SFuGmk6rjESLb-sur1/exec'; 
    // ←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←←

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          guests: formData.guests.toString(),
          message: formData.message,
        }),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setSubmitted(true);
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          guests: 1,
          message: '',
        });
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('RSVP error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="crp-ent-page">
      <header className="crp-ent-hero">
        <div className="crp-ent-hero-content">
          <h1 className="crp-ent-title-main">CARPE <br /> ENTERTAINMENT</h1>
          <p className="crp-ent-hero-subtitle">The Best Live Experiences in Johannesburg</p>
          <a href="#next-event" className="crp-ent-hero-btn">See Next Event</a>
        </div>
      </header>
      
      <section id="next-event" className="crp-ent-section crp-ent-next-event">
        <div className="crp-ent-container">
          <h2 className="crp-ent-section-title">Next Event</h2>
          <div className="crp-ent-event-details">
            <h3 className="crp-ent-event-title">CARPE SESSIONS</h3>
            <p className="crp-ent-event-info">Date: May 1, 2026 | Time: 6:00 PM SAST</p>
            <p className="crp-ent-event-info">Location: Details sent upon RSVP approval</p>
            <p className="crp-ent-event-desc">Join us for an unforgettable night of rhythms and vibes!</p>
            
            <div className="crp-ent-countdown">
              <div className="crp-ent-countdown-item">
                <span className="crp-ent-countdown-value">{timeLeft.months || '00'}</span>
                <p className="crp-ent-countdown-label">Months</p>
              </div>
              <div className="crp-ent-countdown-item">
                <span className="crp-ent-countdown-value">{timeLeft.days || '00'}</span>
                <p className="crp-ent-countdown-label">Days</p>
              </div>
              <div className="crp-ent-countdown-item">
                <span className="crp-ent-countdown-value">{timeLeft.hours || '00'}</span>
                <p className="crp-ent-countdown-label">Hours</p>
              </div>
              <div className="crp-ent-countdown-item">
                <span className="crp-ent-countdown-value">{timeLeft.minutes || '00'}</span>
                <p className="crp-ent-countdown-label">Minutes</p>
              </div>
              <div className="crp-ent-countdown-item">
                <span className="crp-ent-countdown-value">{timeLeft.seconds || '00'}</span>
                <p className="crp-ent-countdown-label">Seconds</p>
              </div>
            </div>
            
            {/* <a href="https://www.howler.co.za/crpentertainmenthp" target="_blank" rel="noopener noreferrer" className="crp-ent-event-btn">
              Buy Tickets
            </a> */}
          </div>
        </div>
      </section>

      {/* ====================== NEW RSVP SECTION ====================== */}
      <section id="rsvp" className="crp-ent-section crp-ent-rsvp">
        <div className="crp-ent-container">
          <h2 className="crp-ent-section-title">RSVP NOW</h2>
          <p className="crp-ent-rsvp-subtitle">
            Limited guest list • Location &amp; details sent after approval
          </p>

          {!submitted ? (
            <form onSubmit={handleRSVP} className="crp-ent-rsvp-form">
              <div className="crp-ent-rsvp-input-group">
                <label htmlFor="name">Full Name <span className="required">*</span></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your full name"
                />
              </div>

              <div className="crp-ent-rsvp-input-group">
                <label htmlFor="email">Email Address <span className="required">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="you@email.com"
                />
              </div>

              <div className="crp-ent-rsvp-input-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+27 12 345 6789"
                />
              </div>

              <div className="crp-ent-rsvp-input-group">
                <label htmlFor="guests">Number of Guests</label>
                <input
                  type="number"
                  id="guests"
                  name="guests"
                  min="1"
                  value={formData.guests}
                  onChange={handleChange}
                />
              </div>

              {/* <div className="crp-ent-rsvp-input-group">
                <label htmlFor="message">Special Requests or Message (optional)</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  placeholder="Dietary needs, song requests, etc."
                />
              </div> */}

              <button
                type="submit"
                className="crp-ent-rsvp-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'SENDING RSVP...' : 'SECURE MY SPOT'}
              </button>
            </form>
          ) : (
            <div className="crp-ent-rsvp-success">
              <div className="crp-ent-rsvp-success-icon">✓</div>
              <h3>THANK YOU!</h3>
              <p>Your RSVP has been received and added to the guest list.</p>
              <p>You’ll receive an email shortly with the exact venue address and any updates.</p>
              <button
                onClick={() => setSubmitted(false)}
                className="crp-ent-rsvp-btn"
                style={{ backgroundColor: 'transparent', border: '2px solid var(--primary-orange)', color: 'var(--primary-orange)' }}
              >
                RSVP FOR SOMEONE ELSE
              </button>
            </div>
          )}
        </div>
      </section>
      {/* ====================== END RSVP SECTION ====================== */}
      
      <footer className="crp-ent-footer">
        <div className="crp-ent-footer-content">
          <p className="crp-ent-footer-text">Connect with CRP Entertainment</p>
          <div className="crp-ent-social-links">
            <a href="https://www.instagram.com/crp.ent/" target="_blank" rel="noopener noreferrer" className="crp-ent-social-link">Instagram</a> |
            <a href="https://x.com/crpnoctem" target="_blank" rel="noopener noreferrer" className="crp-ent-social-link">X</a>
          </div>
          <p className="crp-ent-footer-text-small">&copy; 2026 CRP Entertainment. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default CRPEntPage;